import { VenueUIConfig } from "../types/Config";
import ScoreboardClient from "./ScoreboardClient";

const getHeaders = (venueGuid: string) => ({ headers: { "sse-auth": venueGuid } });

export const getUIConfig = async (venueGuid: string): Promise<VenueUIConfig> =>
  (await ScoreboardClient.get(`/venue/ui/config/${venueGuid}`, getHeaders(venueGuid))).data.entity;

export const saveUIConfig = async (venueGuid: string, config: VenueUIConfig): Promise<VenueUIConfig> =>
  (
    await ScoreboardClient.post(
      `/venue/ui/config/${venueGuid}`,
      {
        ...config,
        strikeZoneConfig: JSON.stringify(config.strikeZoneConfig),
        thinConfig: JSON.stringify(config.thinConfig),
      },
      getHeaders(venueGuid),
    )
  ).data.entity;
